<div class="notification-box" (click)="notification()">
  <i data-feather="bell"></i>
  <span class="badge rounded-pill badge-secondary"> </span>
</div>
<div class="onhover-show-div notification-dropdown" [ngClass]="{'active' : notifications == true}">
  <div class="card mb-0">
    <div class="card-header">
      <div class="common-space">
        <h4 class="text-start f-w-600">Notifications</h4>
        <div><span></span></div>
      </div>
    </div>
    <div class="card-body">
      <div class="notitications-bar">
        <ul class="nav nav-pills nav-primary p-0" id="pills-tab" role="tablist">
          <li class=" p-0">
            No Data Found
          </li>

        </ul>
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" [ngClass]="{'show active': openTab == 'all'}">
            <app-all-user></app-all-user>
          </div>
          <div class="tab-pane fade" id="pills-contactus" [ngClass]="{'show active': openTab == 'Messages'}">
            <app-messages></app-messages>
          </div>
          <div class="tab-pane fade" id="pills-blog" [ngClass]="{'show active': openTab == 'Cart'}">
            <app-notification-cart></app-notification-cart>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="card-footer">
      <div class="text-center">
        <a class="f-w-700">
          <button class="btn btn-primary" type="button" title="btn btn-primary">Check all</button>
        </a>
      </div>
    </div> -->
  </div>
</div>